import React, { useState } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import { makeStyles } from '@material-ui/core/styles';
import { Room, Call, Email } from '@material-ui/icons';
import { Icons } from '../../atoms';
import { Navigation } from '..';
import { IconLogoPutih } from '../../../assets';
import { Box, Typography, Divider, Link } from '@material-ui/core';
import { getContactUsInfo } from '../../../services';
const Fade = require('react-reveal/Fade');

const convertArray2dimension = (arr: any, count: number) => {
  const result: any = [];
  let tempresult = [];

  for (let i = 0; i < count; i++) {
    result.push([]);
  }

  arr.forEach((r: any, i: number) => {
    tempresult.push(i);
    result[tempresult.length - 1].push(r);
    if (tempresult.length === count) {
      tempresult = [];
    }
  });

  return result;
};

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  subTitle: {
    color: theme.palette.common.white,
    display: 'block',
    lineHeight: '1.6em',
    cursor: 'pointer',
  },
}));

const StyledNav = styled.nav`
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  @media screen and (max-width: 1150px) {
    padding-left: 0;
  }
  @media screen and (max-width: 670px) {
    display: none;
  }
`;

const StyledCopyright = styled.div`
  background-color: ${({ theme }) => theme.colors.main};
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const StyledSvg = styled.a`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  margin-right: 8px;
  border-radius: 8px;
  &:hover {
    background-color: #2d2d2d;
  }
`;

const Footer = ({ dataNav, isId }: any) => {
  const classes = useStyles();
  const [grupKamiState, setGrupKamiState] = useState([]);
  const [contactUs, setContactUs] = useState({
    companyName: '',
    address: '',
    email: '',
    tlp: [],
    fb: '',
    ig: '',
    tw: '',
    yt: '',
    title_mobile_app_id: '',
    title_mobile_app_en: '',
    desc_mobile_app_id: '',
    desc_mobile_app_en: '',
  });

  const { companyName, address, email, tlp, fb, ig, tw, yt } = contactUs;

  const fetchContectUsInfo = async () => {
    try {
      const res = await getContactUsInfo();
      setContactUs(res.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const fetchDataGrupKami = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content/gk`
      );
      const resJson = await res.json();
      return resJson.data;
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const fetchGrupKami = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content?type=17`
      );
      const resJson = await res.json();
      const mapResJson = resJson.data.rows
        .reverse()
        .map(({ id, title_id, title_en }: any) => ({
          id,
          title_id,
          title_en,
          data: [],
        }));
      const itemGroupKami = await fetchDataGrupKami();
      itemGroupKami.forEach((r: any) => {
        const index = mapResJson.findIndex((x: any) => x.id === r.id_type);
        mapResJson[index].data.push(r);
      });
      setGrupKamiState(convertArray2dimension(mapResJson, 3));
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    fetchContectUsInfo();
    fetchGrupKami();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        style={{ padding: '32px', paddingTop: 96, backgroundColor: '#424244' }}
      >
        <Typography
          variant='h4'
          align='center'
          style={{ color: '#fff' }}
          gutterBottom
        >
          {isId ? 'Pembangunan Jaya Grup' : 'Pembangunan Jaya Group'}
        </Typography>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '2rem',
            padding: '32px 0',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              maxWidth: 1280,
              flexWrap: 'wrap',
              // gap: 32,
            }}
          >
            {grupKamiState.map((row: any, i: number) => (
              <div style={{ display: 'flex', flexDirection: 'column' }} key={i}>
                {row.map((secondRow: any) => (
                  <Fade delay={i * 200} key={secondRow.id}>
                    <Box style={{ marginBottom: 32 }}>
                      <Typography className={classes.title} gutterBottom>
                        {secondRow[isId ? 'title_id' : 'title_en']}
                      </Typography>
                      {secondRow.data.map((thirdRow: any) => (
                        <Link
                          href={thirdRow.link}
                          target='blank'
                          className={classes.subTitle}
                        >
                          {thirdRow.company}
                        </Link>
                      ))}
                    </Box>
                  </Fade>
                ))}
              </div>
            ))}
          </div>
        </Box>
        <Divider style={{ background: 'white', marginBottom: 32 }} />
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 30,
            flexWrap: 'wrap',
          }}
        >
          <IconLogoPutih style={{ height: 40 }} />
          {/* Icon Footer */}
          <Box style={{ display: 'flex', gap: 8 }}>
            <Room style={{ color: 'white' }} />
            <Box>
              <Typography className={classes.title}>{companyName}</Typography>
              <div style={{ color: 'white' }}>{parse(address)}</div>
            </Box>
          </Box>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Box style={{ display: 'flex', gap: 8 }}>
              <Call style={{ color: 'white' }} />
              <Box>
                {tlp.map((r, i) => (
                  <Typography key={i} gutterBottom style={{ color: 'white' }}>
                    {r}
                  </Typography>
                ))}
              </Box>
            </Box>
            <Box style={{ display: 'flex', gap: 8 }}>
              <Email style={{ color: 'white' }} />
              <Box>
                <Typography style={{ color: 'white' }}>{email}</Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography style={{ color: 'white' }}>Ikuti Kami: </Typography>
            <Box style={{ display: 'flex', marginTop: 8 }}>
              <StyledSvg href={ig} target='_blank'>
                <Icons.IconInstagram width={20} height={20} />
              </StyledSvg>
              <StyledSvg href={yt} target='_blank'>
                <Icons.IconYoutube width={31} height={20} />
              </StyledSvg>
              <StyledSvg href={fb} target='_blank'>
                <Icons.IconFacebook width={15} height={20} />
              </StyledSvg>
              <StyledSvg href={tw} target='_blank'>
                <Icons.IconTwitter width={24} height={20} />
              </StyledSvg>
            </Box>
          </Box>
        </Box>
      </Box>
      <div>
        <StyledNav>
          <Navigation isId={isId} DataNav={dataNav} />
        </StyledNav>
        <StyledCopyright>
          <Typography variant='subtitle2' style={{ color: '#eeeeee' }}>
            &copy; Copyright 2021. Jakarta TollRoad Development All Rights
            Reserved.
          </Typography>
        </StyledCopyright>
      </div>
    </>
  );
};

export default Footer;
